module.exports = __webpack_public_path__ + "img/72625B_F0DFD0_D9BAA5_C3A595-256px.f1eb7362.png";